const resetters = new Map()

export function registerTenantScopedReset(name, reset) {
	if (!name || typeof reset !== 'function') throw new TypeError('Tenant reset requires a name and function')
	resetters.set(name, reset)
	return () => {
		if (resetters.get(name) === reset) resetters.delete(name)
	}
}

export function clearTenantScopedState(reason) {
	const failures = []
	for (const [name, reset] of resetters) {
		try {
			reset(reason)
		} catch (error) {
			failures.push(Object.assign(error instanceof Error ? error : new Error(String(error)), { tenantStateName: name }))
		}
	}
	if (failures.length > 0) {
		throw Object.assign(new Error('Failed to clear tenant-scoped state'), { failures })
	}
}

export function registeredTenantScopedStateNames() {
	return [...resetters.keys()].sort()
}
